// GisExportsPanel — GIS spatial exports panel
import { gisExports } from "@/mocks/relatorios";

const formatIcons: Record<string, string> = {
  "GeoJSON": "ri-code-line",
  "Shapefile": "ri-folder-zip-line",
  "KML/KMZ": "ri-earth-line",
};

export default function GisExportsPanel() {
  return (
    <div className="space-y-5">
      <h3 className="text-sm font-semibold text-foreground-900">Exportações GIS</h3>

      {/* Export form */}
      <div className="bg-white rounded-xl border border-background-200/70 p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Camada</label>
            <select className="w-full px-3 py-2 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-600 cursor-pointer">
              <option value="">Selecione...</option>
              <option>Árvores CTA — Pontos</option>
              <option>Áreas Verdes — Polígonos</option>
              <option>UCs — Polígonos</option>
              <option>Árvores de Risco Crítico</option>
              <option>Vistorias Georreferenciadas</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Projeto</label>
            <select className="w-full px-3 py-2 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-600 cursor-pointer">
              <option value="">Todos</option>
              <option>CTA Urbano Campinas</option>
              <option>Inventário Parque das Acácias</option>
              <option>Gestão UC Mata Verde</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">SRID</label>
            <select className="w-full px-3 py-2 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-600 cursor-pointer">
              <option>EPSG:4326</option>
              <option>EPSG:4674</option>
              <option>EPSG:31983</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Formato</label>
            <select className="w-full px-3 py-2 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-600 cursor-pointer">
              <option>GeoJSON</option>
              <option>Shapefile</option>
              <option>KML/KMZ</option>
            </select>
          </div>
        </div>
        <button className="px-4 py-2 text-sm font-semibold text-white bg-accent-600 rounded-lg hover:bg-accent-700 transition-colors whitespace-nowrap">
          <i className="ri-download-line w-4 h-4 inline-flex items-center justify-center mr-1" />
          Exportar camada
        </button>
      </div>

      {/* GIS layers table */}
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-background-200">
              <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase">Camada</th>
              <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase">Projeto</th>
              <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase">Município</th>
              <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase">SRID</th>
              <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase">Formato</th>
              <th className="text-right py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase">Feições</th>
              <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase">Status</th>
              <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase">Última exportação</th>
              <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase">Ações</th>
            </tr>
          </thead>
          <tbody>
            {gisExports.map((g) => (
              <tr key={g.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="py-2.5 px-3">
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 rounded-lg bg-accent-50 flex items-center justify-center shrink-0">
                      <i className={`${formatIcons[g.format] || "ri-map-2-line"} text-accent-500 w-full h-full flex items-center justify-center text-sm`} />
                    </div>
                    <span className="font-medium text-foreground-900 text-xs">{g.layer}</span>
                  </div>
                </td>
                <td className="py-2.5 px-3 text-foreground-600 text-xs max-w-[120px] truncate">{g.project}</td>
                <td className="py-2.5 px-3 text-foreground-600 text-xs">{g.municipality}</td>
                <td className="py-2.5 px-3">
                  <span className="text-xs font-mono text-accent-600 bg-accent-50 px-2 py-0.5 rounded">{g.srid}</span>
                </td>
                <td className="py-2.5 px-3">
                  <span className="text-xs font-medium text-foreground-600 bg-background-50 px-2 py-0.5 rounded border border-background-200">{g.format}</span>
                </td>
                <td className="py-2.5 px-3 text-foreground-900 text-xs text-right font-mono">{g.featureCount.toLocaleString()}</td>
                <td className="py-2.5 px-3">
                  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${
                    g.status === "Disponível" ? "bg-primary-100 text-primary-700" : "bg-orange-100 text-orange-700"
                  }`}>
                    {g.status === "Em processamento" && <i className="ri-loader-4-line w-3 h-3 flex items-center justify-center animate-spin" />}
                    {g.status}
                  </span>
                </td>
                <td className="py-2.5 px-3 text-foreground-500 text-xs">{g.lastExported}</td>
                <td className="py-2.5 px-3">
                  <div className="flex items-center gap-1">
                    <button title="Exportar" className="w-7 h-7 rounded-md flex items-center justify-center text-foreground-400 hover:text-accent-600 hover:bg-accent-50 transition-colors">
                      <i className="ri-download-line w-4 h-4 flex items-center justify-center text-sm" />
                    </button>
                    <button title="Ver no mapa" className="w-7 h-7 rounded-md flex items-center justify-center text-foreground-400 hover:text-primary-600 hover:bg-primary-50 transition-colors">
                      <i className="ri-map-2-line w-4 h-4 flex items-center justify-center text-sm" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}